import { AnalyticsEvent } from "Shared/services/analytics/config";
import { ANALYTICS_EVENT_ATTRIBUTES, ANALYTICS_EVENT_NAMES,ANALYTICS_EVENT_SUB_TYPE,ANALYTICS_EVENT_TYPE } from "Shared/services/analytics/constants";
import { GA4_EVENT_CATEGORY, trackEventConditionally } from "Shared/services/analytics/services/thresholdManager";

export type QuestionnaireStartEvent = {
  [ANALYTICS_EVENT_ATTRIBUTES.sub_type]   : ANALYTICS_EVENT_SUB_TYPE,
  [ANALYTICS_EVENT_ATTRIBUTES.total_steps]: number,
}

/**
 * Sends analytic event and attributes for Questionnaire to Google Analytics
 * @param questionnaireStartEvent
 * @returns void
 */
export const analyticsTrackQuestionnaireStart = (questionnaireStartEvent: QuestionnaireStartEvent): void => {
  const event: AnalyticsEvent = {
    event     : ANALYTICS_EVENT_NAMES.start,
    attributes: {
      ...questionnaireStartEvent,
      [ANALYTICS_EVENT_ATTRIBUTES.type]: ANALYTICS_EVENT_TYPE.questionnaire,
    }
  };

  switch (questionnaireStartEvent[ANALYTICS_EVENT_ATTRIBUTES.sub_type]) {
    case ANALYTICS_EVENT_SUB_TYPE.survey_qualification:
      trackEventConditionally(GA4_EVENT_CATEGORY.survey_qualification, [event]);
      break;
    case ANALYTICS_EVENT_SUB_TYPE.survey_medley:
      trackEventConditionally(GA4_EVENT_CATEGORY.survey_medley, [event]);
      break;
    default:
      trackEventConditionally(GA4_EVENT_CATEGORY.aquisition, [event]);
      break;
  }
};